export type TabsOrderType = Readonly<{
  spmVisible: string[];
  spmHidden: string[];
}>;

export const emptyTabsOrder: TabsOrderType = {
  spmVisible: [],
  spmHidden: [],
};
